<template>
  <button
    v-show="isRemoveBtnVisible"
    class="remove-photo my-0"
    type="button"
    @click="$emit('remove')"
  >
    <slot>Remove photo</slot>
  </button>
</template>

<script>
export default {
  name: "RemovePhoto",
  props: {
    isRemoveBtnVisible: Boolean,
  },
};
</script>

<style scoped>
.remove-photo {
  color: var(--ch-blue-100);
  font-size: 0.875rem;
  font-weight: 700;
}
</style>
